import { initContentScript } from "./initContentScript";

initContentScript();
